import gql from 'graphql-tag';
import moment from 'moment';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
	ADMIN_GAMES, ADMIN_SESSION,
	ADMIN_SESSIONS,

	ADMIN_USERS
} from '../../routes';
import AdminCover from '../AdminCover';
import AdminFooter from '../AdminFooter';
import AdminGames from '../AdminGames';
import AdminHeader from '../AdminHeader';
import AdminNavigation from '../AdminNavigation';
import AdminSessionDetail from '../AdminSessionDetail';
import AdminSessions from '../AdminSessions';
import AdminUsers from '../AdminUsers';
import Loader from '../Loader';
import './styles.scss';

const ADMIN_QUERY = gql`
	query adminQuery{
		users {
			id
			username
			password
			firstName
			lastName
			roles
		}
		user {
			id
			username
			password
			firstName
			lastName
			roles
			gamesCount
			teams
			scenarios{
				id
				name
			}
			sessions {
				id
				name
				date
				teamsCount
				startDate
				endDate
				creator {
					id
				}
				scenarioID
				owners {
					id
					username
					password
					firstName
					lastName
					roles
				}
			}
		}
	}
`;

class Admin extends Component {

  
	parserDate(date){
		return date
			? moment(parseInt(date)).format('D MMMM YYYY, h:mm')
			: 'N.A.'
	}

	getSessionsArray(data) {
		const { sessions, scenarios } = data.user;
		return sessions.map(session => {
			const { id, name, date, owners, creator, teamsCount, startDate, endDate, scenarioID } = session;
			const scenario = scenarios.find(({ id }) => id === scenarioID);
			return {
				id,
				name,
				games: [],
				owners,
				creator,
				team: teamsCount,
				actions: '',
				createdAtRaw: date,
				createdAt: this.parserDate(date),
				startDate: this.parserDate(startDate),
				endDate: this.parserDate(endDate),
				scenario: scenario ? scenario.name : ''
			};
		});
	}

	getUsersArray(data) {
		const { users } = data;

		return users.map(user => {
			return {
				id: user.id,
				firstName: user.firstName,
				lastName: user.lastName,
				username: user.username,
				password: user.password,
				rolesOutput: user.roles?.join('<br/>'),
				roles: user.roles,
				actions: ''
			};
		});
	}

	render() {

		return (
			<Query
				query={ADMIN_QUERY}
				fetchPolicy={'cache-and-network'}
			>
				{({ data, loading }) => {
					if (loading || !data.user || !data.users) {
						return <Loader />;
					}
					const { gamesCount } = data.user;
					return (
						<div className="Admin">
							<AdminHeader />
							<AdminCover user={data.user} />
							<div className="Admin-content">
								<div className="Admin-menu">
									<AdminNavigation
										title={'Overview'}
										sessions={this.getSessionsArray(data)}
										games={gamesCount}
										users={this.getUsersArray(data)}
									/>
								</div>
								<div className="Admin-routes">
									<Switch>
										<Route
											path={ADMIN_SESSION}
											exact
											render={props => (
												<AdminSessionDetail
													{...props}
													users={this.getUsersArray(data)}
													sessions={this.getSessionsArray(data)}
												/>
											)}
										/>
										<Route
											path={ADMIN_SESSIONS}
											exact
											render={props => (
												<AdminSessions
													{...props}
													sessions={this.getSessionsArray(data)}
													scenarios={data.user.scenarios}
												/>
											)}
										/>
										<Route
											path={ADMIN_GAMES}
											render={props => (
												<AdminGames
													{...props}
													teams={data.user.teams}
													sessions={this.getSessionsArray(data)}
													users={this.getUsersArray(data)}
												/>
											)}
										/>
										<Route
											path={ADMIN_USERS}
											render={props => (
												<AdminUsers
													{...props}
													users={this.getUsersArray(data)}
													user={data.user}
												/>
											)}
										/>
										<Redirect to={ADMIN_SESSIONS} />
									</Switch>
								</div>
							</div>
							<AdminFooter />
						</div>
					)
				}
				}
			</Query>
		);
	}
}

export default Admin;
